export function truncateString(str, maxLength) {
  if (str.length <= maxLength) {
    return str;
  } else {
    return str.substring(0, maxLength) + "...";
  }
}

export const capitalize = (text: string) => {
  return (text && text[0].toUpperCase() + text.slice(1)) || "";
};

export const formatPhoneNumber = (phoneNumber) => {
  if (!phoneNumber) return "";
  const cleaned = ("" + phoneNumber).replace(/\D/g, "");
  const match = cleaned.match(/^(\d{3})(\d{3})(\d{4})$/);
  if (match) {
    return `(${match[1]}) ${match[2]}-${match[3]}`;
  }
  return phoneNumber;
};

export const toClass = (text: string) => {
  return text.toLowerCase().replace(/\s+/g, "-");
};

// Ordinal numbers
const english_ordinal_rules = new Intl.PluralRules("en", { type: "ordinal" });
const suffixes = {
  one: "st",
  two: "nd",
  few: "rd",
  other: "th",
};
export function ordinalize(number) {
  const category = english_ordinal_rules.select(number);
  const suffix = suffixes[category];
  return number + suffix;
}

export const snakeCaseToTitle = (string) => {
  if (string.includes("_")) {
    return string.split("_").map(capitalize).join(" ");
  }
  return capitalize(string);
};

export const questionnaireTypeToDisplay = (type) => {
  const hash = {
    standard: "Standard",
    diabetes_management: "NDPERS Diabetes Program",
    one_program: "ONE Program",
  };
  return hash[type];
};

export function formatZip(zip) {
  if (!zip) return "";

  const normalized = zip.replace(/\D/g, "");

  if (/^\d{9}$/.test(normalized)) {
    return `${normalized.slice(0, 5)}-${normalized.slice(5)}`;
  } else if (/^\d{5}-\d{4}$/.test(zip)) {
    return zip;
  } else {
    return zip.slice(0, 5);
  }
}

export const validateEmail = (email: string) => {
  const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return regex.test(email);
};

export function normalize(value) {
  if (!value) return ""; // handle null, undefined, or empty
  return String(value).toUpperCase().replace(/[^A-Z0-9]/g, "");
}

export function formatMrn(raw) {
  const r = normalize(raw);
  if (r.length < 8) return r; // too short, just return normalized
  return `${r.slice(0, 3)}-${r.slice(3, 7)}-${r.slice(7, 8)}`;
}
